<a class="nav-link" (click)="showLicenceDialog()" id="licensing">
  <span class="fa-stack fa-lg">
    <i class="fa fa-key fa-stack-1-3x" [ngClass]="{ invalid: !isValid }"></i>
    <i *ngIf="!isValid" class="fa fa-exclamation-triangle fa-stack-1x" style="color: red;"></i>
    <i *ngIf="isValid && showWarningIcon" class="fa fa-exclamation-triangle fa-stack-1x"></i>
  </span>
  <span class="licence-label">{{'Licensing' | i18next}}</span>
</a>
